import { memo, ReactElement, useCallback } from 'react';
import { useAtom } from 'jotai';
import { App, Switch } from 'antd';
import type { BranchCode } from '../types';
import { forwardToTokyoAtomFamily } from '../atoms/settingAtoms';
import { SectionHeading, ToggleSection, ToggleNote, ToggleRow, ToggleLabel } from './styles';

interface Props {
  branchCode: BranchCode;
}

const ForwardDestinationToggle = memo(function ForwardDestinationToggle({ branchCode }: Props): ReactElement {
  const { message } = App.useApp();
  const [forwardToTokyo, setForwardToTokyo] = useAtom(forwardToTokyoAtomFamily(branchCode));

  const handleChange = useCallback(
    (checked: boolean) => {
      // MOCK [#239]: 本番実装時はバックエンドへの保存リクエストに置き換える。
      setForwardToTokyo(checked);
      void message.success(checked ? '転送先を東京拠点に切り替えました' : '転送先を自拠点に戻しました');
    },
    [setForwardToTokyo, message]
  );

  return (
    <>
      <SectionHeading>転送先の変更</SectionHeading>
      <ToggleSection>
        <ToggleNote>
          応募者への架電後に転送する先を切り替えます。
          <br />
          通常は自拠点の電話番号へ転送しますが、ONにしている間は東京拠点の電話番号へ転送します。
        </ToggleNote>
        <ToggleRow>
          <ToggleLabel>転送先を東京拠点に切り替える</ToggleLabel>
          <Switch checked={forwardToTokyo} onChange={handleChange} aria-label='転送先を東京拠点に切り替える' />
        </ToggleRow>
      </ToggleSection>
    </>
  );
});

export default ForwardDestinationToggle;
